module.exports = __webpack_public_path__ + "img/saved.1b39bb19.svg";